import { render } from "./AIQPersonas.vue?vue&type=template&id=0a09f216&scoped=true"
import script from "../js/aiq-personas.js?vue&type=script&lang=js"
export * from "../js/aiq-personas.js?vue&type=script&lang=js"

import "./AIQPersonas.vue?vue&type=style&index=0&id=0a09f216&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a09f216"]])

export default __exports__